import PropTypes from 'prop-types';
import * as MuiIcons from '@mui/icons-material';
import { themeColors } from '../theme/theme';

// Map your custom icon names to MUI icon components or fallback
const iconMap = {
  home: MuiIcons.Home,
  // plant: MuiIcons.Eco, // fixed from MuiIcons.EcoOutlined
  tools: MuiIcons.Build,
  user: MuiIcons.Person,
  search: MuiIcons.Search,
  notifications: MuiIcons.Notifications,
  star: MuiIcons.Star,
  help: MuiIcons.Help,
  account_balance_wallet: MuiIcons.AccountBalanceWallet,
  history: MuiIcons.History,
  manage_accounts: MuiIcons.ManageAccounts,
  local_offer: MuiIcons.LocalOffer,
  close: MuiIcons.Close,
  arrow_back: MuiIcons.ArrowBack,
  arrow_back_ios: MuiIcons.ArrowBackIos,
  arrow_forward_ios: MuiIcons.ArrowForwardIos,
  check: MuiIcons.Check,
  LocationOn: MuiIcons.LocationOn,
  Inventory2: MuiIcons.Inventory2,
  Category: MuiIcons.Category,
  MyLocationOutlined: MuiIcons.MyLocationOutlined,
  ArrowBack: MuiIcons.ArrowBack,
  RestoreOutlined: MuiIcons.RestoreOutlined,
  EditOutlined: MuiIcons.EditOutlined,
  SupportAgentOutlined: MuiIcons.SupportAgentOutlined,
  LocationOnOutlined: MuiIcons.LocationOnOutlined,
  SportsScoreOutlined: MuiIcons.SportsScoreOutlined,
  CategoryOutlined: MuiIcons.CategoryOutlined,
  StraightenOutlined: MuiIcons.StraightenOutlined,
  SortRounded: MuiIcons.SortRounded,
  LocalShippingOutlined: MuiIcons.LocalShippingOutlined,
  WarningAmberRounded: MuiIcons.WarningAmberRounded,
  PlaceOutlined: MuiIcons.PlaceOutlined,
  LockOpenOutlined: MuiIcons.LockOpenOutlined,
  SecurityOutlined: MuiIcons.SecurityOutlined,
  LogoutOutlined: MuiIcons.LogoutOutlined,
  KeyboardArrowRightRounded: MuiIcons.KeyboardArrowRightRounded,
  CurrencyRupeeRounded: MuiIcons.CurrencyRupeeRounded,
  ExpandLess: MuiIcons.ExpandLess,
  ExpandMore: MuiIcons.ExpandMore,
  // Add more mappings as needed
};

export function Icon({ name, color, size = 'medium', style, ...props }) {
  const IconComponent = iconMap[name] || MuiIcons.HelpOutline;
  // Use themeColors.iconColor unless color is explicitly set to 'primary' or 'secondary'
  let resolvedColor = color;
  let resolvedStyle = { ...style };
  if (!color || color === 'inherit') {
    resolvedStyle.color = themeColors.iconColor;
    resolvedColor = 'inherit';
  } else if (color === 'primary' || color === 'secondary') {
    // Let MUI handle primary/secondary
  } else {
    resolvedStyle.color = color;
    resolvedColor = 'inherit';
  }
  return <IconComponent fontSize={size} color={resolvedColor} style={resolvedStyle} {...props} />;
}

Icon.propTypes = {
  name: PropTypes.string.isRequired,
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  color: PropTypes.string,
  style: PropTypes.object,
};
